// Mapeia permissões em rotas iniciais para fallback quando o usuário não tem
// acesso ao Dashboard (FDashboard). Ordem = prioridade de negócio.
const ROTAS_POR_PERMISSAO = [
  { permissao: 'PedidosAtendimento', rota: '/pedidos' },
  { permissao: 'PontodeVenda', rota: '/prevenda' },
  { permissao: 'PDV', rota: '/pdv' },
  { permissao: 'Venda', rota: '/venda' },
  { permissao: 'RelVenda', rota: '/relatorio-vendas' },
  { permissao: 'LancamentoConta', rota: '/contas' },
  { permissao: 'NFE', rota: '/nfe' },
  { permissao: 'CadProduto', rota: '/cadproduto' },
  { permissao: 'CadUsuarios', rota: '/cadusuario' },
  { permissao: 'ConsultaMovDiarias', rota: '/consultas/movimentacoes-diarias' },
  { permissao: 'Autoatendimento', rota: '/autoatendimento' },
];

export function primeiraRotaPermitida(permissoes) {
  const lista = Array.isArray(permissoes) ? permissoes : [];
  for (const item of ROTAS_POR_PERMISSAO) {
    if (lista.includes(item.permissao)) return item.rota;
  }
  return '/auth/login';
}
